import { Button } from "components/shared";
import React, { FC, useEffect, useState } from "react";
import { MyInput } from "../../MyInput/MyInput";
import { MySelect } from "../../MySelect/MySelect";
import { MyTextarea } from "../../MyTextarea/MyTextarea";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import {
	getActivityAreasDirectory,
	getObjectsTypesDirectory,
	getOwnershipTypesDirectory,
	getResponsiblesDirectory,
} from "toolkit/directories/directories.thunks";
import { DeletingLine } from "../../BusinessProcesses/DeletingLine/DeletingLine";
import { createObject, deleteObject, editObject } from "toolkit/steps/stepTwo/objectsRegister/objectsRegister.thunks";
import { useParams } from "react-router-dom";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { SuccessForm } from "../SuccessForm/SuccessForm";
import { connectNames } from "helpers";
import InputTemp from "components-new/InputTemp";
import styles from "./AddingAndEditionObject.module.sass";

interface AddingAndEditionObjectProps {
	type: "add" | "edit";
	object: any | null;
	close: () => void;
}

interface ISelect {
	id: number | null;
	name: string;
}

export const AddingAndEditionObject: FC<AddingAndEditionObjectProps> = ({ type, object, close }) => {
	const { objectsTypesDirectory, activityAreasDirectory, responsiblesDirectory, ownershipTypesDirectory } =
		useAppSelector((state) => state.directories);
	const [objectType, setObjectType] = useState<ISelect>({ id: null, name: "" });
	const [name, setName] = useState<string>("");
	const [code, setCode] = useState<string>("");
	const [activityArea, setActivityArea] = useState<ISelect>({ id: null, name: "" });
	const [responsible, setResponsible] = useState<ISelect>({ id: null, name: "" });
	const [ownershipType, setOwnershipType] = useState<ISelect>({ id: null, name: "" });
	const [purpose, setPurpose] = useState<string>("");
	const [document, setDocument] = useState<any>(null);
	const [submitError, setSubmitError] = useState<boolean>(false);
	const [desireDelete, setDesireDelete] = useState<boolean>(false);
	const [newDocument, setNewDocument] = useState<any>(null);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [responsiblesList, setResponsiblesList] = useState<any[]>([]);
	const dispatch = useAppDispatch();
	const creatorId = useAppSelector((state) => state.profile.profile.id);
	const { organizationId } = useParams();
	const [submitSuccess, setSubmitSuccess] = useState<boolean>(false);
	const [newObject, setNewObject] = useState<{}>({});
	const urlParams = useParams();

	useEffect(() => {
		dispatch(getObjectsTypesDirectory());
		dispatch(getActivityAreasDirectory());
		dispatch(getResponsiblesDirectory(Number(organizationId)));
		dispatch(getOwnershipTypesDirectory());
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (responsiblesDirectory.length) {
			const newResponsiblesDirectory: any[] = [];
			// eslint-disable-next-line array-callback-return
			responsiblesDirectory.map((item) => {
				newResponsiblesDirectory.push({ id: item.id, name: connectNames(item), subtitle: item.position });
			});
			setResponsiblesList(newResponsiblesDirectory);
		}
	}, [responsiblesDirectory]);

	useEffect(() => {
		if (type === "edit") {
			setObjectType(object.objectType);
			setName(object.name);
			setCode(object.code);
			setActivityArea(object.activityArea);
			setResponsible({
				id: object.responsible.id,
				name: `${object.responsible.lastName} ${object.responsible.firstName} ${object.responsible.middleName}`,
			});
			setOwnershipType({ id: object.ownershipType.id, name: object.ownershipType.name });
			setPurpose(object.purpose);
			setDocument(object.document);
		}
		//eslint-disable-next-line
	}, []);

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (!organizationId) return;
		if (
			!objectType.id ||
			!name.trim() ||
			!code.trim() ||
			!activityArea.id ||
			!responsible.id ||
			!ownershipType.id ||
			!purpose.trim()
		) {
			setSubmitError(true);
		} else {
			setSubmitError(false);

			switch (type) {
				case "add":
					dispatch(
						createObject({
							organizationId: +organizationId,
							object: {
								objectType: objectType.id,
								name,
								code,
								activityArea: activityArea.id,
								responsible: responsible.id,
								ownershipType: ownershipType.id,
								purpose,
								creator: creatorId,
							},
							document,
							setNewObject: (obj: any) => setNewObject(obj),
							setSubmitSuccess: () => setSubmitSuccess(true),
						}),
					);
					break;
				case "edit":
					dispatch(
						editObject({
							object: {
								objectType: objectType.id,
								name,
								code,
								activityArea: activityArea.id,
								responsible: responsible.id,
								ownershipType: ownershipType.id,
								purpose,
								creator: creatorId,
								id: object.id,
							},
							document: newDocument,
							submitSuccessHandler: () => setSubmitSuccess(true),
						}),
					);
					break;
				default:
					break;
			}
		}
	};

	const deleteHandler = () => {
		dispatch(deleteObject(object.id));
	};

	const attachmentHandler = (file: any) => {
		if (type === "add") setDocument(file);
		else setNewDocument(file);
	};

	return (
		<>
			{submitSuccess && (
				<ModalWindow close={() => setSubmitSuccess(false)}>
					<SuccessForm closeAll={close} close={() => setSubmitSuccess(false)} object={newObject} />
				</ModalWindow>
			)}
			{desireDelete && (
				<ModalWindow close={() => setDesireDelete(false)}>
					<DeletingLine
						close={() => setDesireDelete(false)}
						closeAll={close}
						toDelete={deleteHandler}
						title={"Удалить объект?"}
					/>
				</ModalWindow>
			)}
			<section className={styles.wrp}>
				<h4 className={styles.title}>{type === "add" ? "Добавление объекта" : "Редактирование объекта"}</h4>
				{type === "edit" && (
					<div className={styles["delete-wrp"]}>
						<button onClick={() => setDesireDelete(true)} className={styles["delete-btn"]}>
							Удалить объект
						</button>
					</div>
				)}
				<form onSubmit={submitHandler} className={styles.form}>
					<div className={styles["form-wrp"]}>
						<div className={styles["item-wrp"]}>
							<MySelect
								list={objectsTypesDirectory}
								value={objectType.name}
								set={(selected) => {
									setObjectType(selected);
								}}
								name="Тип объекта"
								placeholder="Выберите тип объекта"
								width="half"
								required={true}
								error={submitError}
							/>
							<MyInput
								width="half"
								className={styles.item}
								required={true}
								condition={submitError && !name.trim()}
								name="Наименование"
								placeholder="Информационная система “Монитор”"
								value={name}
								set={(e) => {
									setName(e.target.value);
								}}
							/>
						</div>
						<div className={styles["item-wrp"]}>
							<MyInput
								className={styles.item}
								required={true}
								condition={submitError && !code.trim()}
								name="Код"
								placeholder="ИС-1"
								value={code}
								set={(e) => {
									setCode(e.target.value);
								}}
							/>
							<MySelect
								list={activityAreasDirectory}
								value={activityArea.name}
								set={(selected) => {
									setActivityArea(selected);
								}}
								name="Сфера деятельности"
								placeholder="Оказание услуг по передаче электроэнергии"
								required={true}
								error={submitError}
							/>
						</div>
						<div className={styles["item-wrp"]}>
							<InputTemp
								value={responsible.name}
								onSelect={(selected) => {
									setResponsible({ id: selected.id, name: selected.fullName });
								}}
								label="Ответственный"
								placeholder="Константинопольский Константин Константинович"
								required={true}
								subTitle={["position"]}
								field={"fullName"}
								error={submitError}
								remote={{
									link: "/employees/short",
									initialParams: {
										page: 1,
										num: 20,
										org: urlParams.organizationId,
									},
								}}
								onChange={({ target }) => {
									const { value: name } = target;
									setResponsible((prevState) => ({ ...prevState, name }));
								}}
							/>
							<MySelect
								list={ownershipTypesDirectory}
								value={ownershipType.name}
								set={(selected) => {
									setOwnershipType(selected);
								}}
								name="Вид владения объектом"
								placeholder="Вид владения объектом"
								required={true}
								error={submitError}
								width="half"
							/>
						</div>
						<div className={styles["item-wrp"]}>
							<MyTextarea
								name="Назначение"
								value={purpose}
								set={(e) => {
									setPurpose(e.target.value);
								}}
								placeholder=" а) Информационная поддержка принятия управленческих решений;
                            б) Мониторинг и управление потоками клиентов;
                            в) Ведение электронной карты клиента;
                            г) Организация проверочных мероприятий.
                            "
								required={true}
								error={submitError}
								width="full"
								maxLength={500}
							/>
						</div>
					</div>
					<div className={styles.btns}>
						<label htmlFor={`uploadDoc`} className={styles.label}>
							{type === "add"
								? document
									? document.name
									: "Прикрепить документ"
								: newDocument?.name || document?.fullName || "Прикрепить документ"}
						</label>
						<input
							onChange={(e) => attachmentHandler(e.target.files![0])}
							type="file"
							id={`uploadDoc`}
							className="none"
							accept=".docx, .pdf, .rtf"
						/>

						<div className={styles["btns-wrp"]}>
							<Button onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED}>
								Отменить
							</Button>
							<Button type="submit">{type === "add" ? "Готово" : "Сохранить"}</Button>
						</div>
					</div>
				</form>
			</section>
		</>
	);
};
